import { Box, Grid } from "@material-ui/core";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import React from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import useCompleoView from "customHooks/useCompleoView";
import useJobContext from "../useJobContext";
import useGetMetadata from "customHooks/useGetMetadata";
import { useApi } from "customHooks/useApi";
import { useAuthState } from "_ReactContext/AuthContext";
import useJobAccess from "customHooks/useAccess/useJobAccess";
import useJobFieldsToHide from "Pages/Job/components/useJobFieldsToHide";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            flexGrow: 1,
            flexDirection: "column",
            backgroundColor: theme.palette.backgroundGrey.main
            // width: "100%"
        }
    })
);

const JobViewDataMain = (props: any) => {
    const classes = useStyles();
    const { company, timeZone } = useAuthState();
    const jobAccess = useJobAccess();

    const [data] = useJobContext();
    const { language, t } = data;
    const moduleName = data.module;
    const [metadata] = useGetMetadata(moduleName);
    const postAddress = `/job/editview`;
    const [addJobReturn, addJob] = useApi(postAddress, "post");
    const { fieldsToHide } = useJobFieldsToHide(null);

    // Filter metadata to hide responsibilities/requirements when company flags are not enabled
    // Also filter out form groups that would be empty after field filtering
    const filteredMetadata = React.useMemo(() => {
        if (!metadata.response?.data?.metadado) {
            return metadata;
        }

        const originalFields = metadata.response.data.metadado;
        const filteredFields = fieldsToHide.length > 0
            ? originalFields.filter(
                (field: any) => !fieldsToHide.includes(field.fieldName)
            )
            : originalFields;

        // Find form groups that would have visible fields after filtering
        const formGroupsWithFields = new Set(
            filteredFields.map((field: any) => field.formGroupId)
        );

        // Filter out empty form groups from formGroups array
        const originalFormGroups = metadata.response.data.formGroups || [];
        const filteredFormGroups = originalFormGroups.filter(
            (group: any) => formGroupsWithFields.has(group.id)
        );

        return {
            ...metadata,
            response: {
                ...metadata.response,
                data: {
                    ...metadata.response.data,
                    metadado: filteredFields,
                    formGroups: filteredFormGroups
                }
            }
        };
    }, [metadata, fieldsToHide]);

    const { formRetorno, finished } = useCompleoView({
        language: language,
        t: t,
        metadataReturn: filteredMetadata,
        ready: data.Job.ready,
        valuesFromSource: { ...data.Job.data },
        timeZone: timeZone,
        editParams: {
            moduleEditName: data.module,
            postFunction: addJob,
            postReturn: addJobReturn,
            keyData: { id: data.JobId, companyId: company.companyId },
            useQueryKeyInvalidate: [data.apiKeyJob],
            customLists: data.EditJobListDefinition,
            fieldsToHide: fieldsToHide
        },
        readOnly: !jobAccess.allowEdit
    });

    return <Box className={classes.container}>{formRetorno}</Box>;
};

export default JobViewDataMain;
